import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./pap.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import MenuItem from "@mui/material/MenuItem";
import { TextField } from '@material-ui/core';
import { Grammarly } from "@grammarly/editor-sdk-react";

import NpsRating from "../../NPS";


type RuleFn = (state: any, value: any) => void;

type FieldMapping = Record<string, FieldMappingConfig>;

interface FieldMappingConfig {
    paramName: string;
    type: 'free_text' | 'checkbox';
    condition?: (state: any) => boolean;
    getValue?: (state: any) => any;
}


interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const PapSmearReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState();
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);



    const [papReportDetails, setPapReportDetails] = useState({
        specimenDetails: {
            receivedType: null, // "slides" | "liquid"

            slides: {
                slidesValue: ""
            },

            liquid: {
                brushType: null, // "with" | "without"
                liquidValue: "",
                withoutBrushValue: ""
            },
        },

        specimenAdequacy: {
            satisfactory: false,

            transformationZone: {
                enabled: false,
                value: null, // "present" | "absent"
            },

            interpretationLimited: {
                enabled: false,
                reason: null, // "blood" | "inflammation" | "other"
                otherText: "",
            },

            unsatisfactory: {
                enabled: false,
                reason: null, // "insufficient" | "other"
                otherText: "",
            },
        },

        findings: {
            endocervicalCells: {
                enabled: false,
                value: null, // "present" | "absent"
            },

            empty_field: {
                enabled: false,
                value: ""
            },

            inflammation: {
                severity: null, // "mild" | "moderate" | "marked"
            },

            otherChanges: {
                value: null // "metaplasia" | "keratotic" | "atrophy"
            },


            organisms: {
                endoMetrical: false,
                trichomonas: null, // "seen" | "not_seen"
                candida: null, // "seen" | "not_seen"
                bacterialVaginosis: false,
                actinomyces: false,
                hsv: false,
                cmv: false,
            },
        },

        impression: {
            multiple_options: {
                enabled: false,
                value: null // trichomonas_vaginalis , Candida species, ...
            },


            atypical_endocervical_nos: {
                enabled: false,
                value: ""
            },
            atypical_endometrical: {
                enabled: false,
                value: ""
            },

            atypical_glandular_nos: {
                enabled: false,
                value: ""
            },

            empty_field: {
                enabled: false,
                value: ""
            },
            singleField: {
                nilm: false,
                cellular_with_inflammation: false,
                atrophy: false,
                ascus: false,
                lsil: false,
                hsil: false,
                hsil_with_suspicious: false,
                carcinoma: false,
                endometrical_favor_neoplastic: false,
                endocervical_favor_neoplastic: false,
                situ: false,
                endocervical_adenocarcinoma: false,
                endometrical_adenocarcinoma: false,
                extrauterine_adenocarcinoma: false,
                adenocarcinoma_nos: false

            }

        },
        advice: {
            clinicalCorrelation: false,
            repeatSmear: false,
            colposcopicFollowUp: false,
        }
    });


    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);




    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [papReport, setPapReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking?.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setPapReport(data);
    }, [reportListParameter])




    console.log(papReport,"papReport");

    useEffect(() => {
        setSample_Collected(papReport[0]?.collection_date);
        setSample_Receivedtime(papReport[0]?.pickup_time);
        setdesignation(papReport[0]?.designation);
        setGender(papReport[0]?.customer_gender);
        setSample_Received(papReport[0]?.pickup_date);
        setName(papReport[0]?.customer_name);
        setAge(papReport[0]?.customer_age);
        setDob(papReport[0]?.dob);
        setUuid(papReport[0]?.uuid);
    }, [papReport]);



    console.log(papReport,  papReport[0]?.designation,"iocdsicunsdi");
    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(papReport[0]?.customer_age);
        }
    }, [dob]);

    //Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }
    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }


    

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    //Hospital ID
    const [HosptalID, setHospitalID] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id &&
            reportListParameter?.Hospital_Id.length > 0
        ) {
            reportListParameter?.Hospital_Id?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalID(data);
    }, [reportListParameter]);

    const updateHospitalId = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HosptalID]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalID(storeData);
    }
    //doctor list
    const [pmldoctorList, setpmldoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setpmldoctorList(data);
    }, [reportListParameter]);


    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...pmldoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setpmldoctorList(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }

const RULES: Record<string, RuleFn> = {
        // --- Specimen Details ---
        "specimenDetails.receivedType": (state, value) => {
            if (value === "slides") {
                state.specimenDetails.liquid = {
                    brushType: null,
                    liquidValue: "",
                    withoutBrushValue: "",
                };
            }
            if (value === "liquid") {
                state.specimenDetails.slides.slidesValue = "";
            }
        },

        "specimenDetails.liquid.brushType": (state, value) => {
            if (value === "with") {
                state.specimenDetails.liquid.withoutBrushValue = "";
            }
        },

        // --- Specimen Adequacy ---
        "specimenAdequacy.transformationZone.enabled": (state, value) => {
            if (!value) {
                state.specimenAdequacy.transformationZone.value = null;
            }
        },

        "specimenAdequacy.transformationZone.value": (state, value) => {
            if (value) {
                state.specimenAdequacy.transformationZone.enabled = true;
            }
        },

        "specimenAdequacy.interpretationLimited.enabled": (state, value) => {
            if (!value) {
                state.specimenAdequacy.interpretationLimited.reason = null;
                state.specimenAdequacy.interpretationLimited.otherText = "";
            }
        },

        "specimenAdequacy.interpretationLimited.reason": (state, value) => {
            if (value) {
                state.specimenAdequacy.interpretationLimited.enabled = true;
            }
            if (value !== "other") {
                state.specimenAdequacy.interpretationLimited.otherText = "";
            }
        },

        "specimenAdequacy.unsatisfactory.enabled": (state, value) => {
            if (!value) {
                state.specimenAdequacy.unsatisfactory.reason = null;
                state.specimenAdequacy.unsatisfactory.otherText = "";
            }
        },

        "specimenAdequacy.unsatisfactory.reason": (state, value) => {
            if (value) {
                state.specimenAdequacy.unsatisfactory.enabled = true;
            }
            if (value !== "other") {
                state.specimenAdequacy.unsatisfactory.otherText = "";
            }
        },

        // --- Findings ---
        "findings.endocervicalCells.enabled": (state, value) => {
            if (!value) {
                state.findings.endocervicalCells.value = null;
            }
        },

        "findings.endocervicalCells.value": (state, value) => {
            state.findings.endocervicalCells.enabled = !!value;
        },

        "findings.empty_field.enabled": (state, value) => {
            if (!value) {
                state.findings.empty_field.value = "";
            }
        },

        // --- Impression ---
        "impression.multiple_options.enabled": (state, value) => {
            if (!value) {
                state.impression.multiple_options.value = null;
            }
        },

        // No RULES for `impression.multiple_options.value`.
        // Selecting a radio should not auto-toggle any other Impression field.

        "impression.atypical_endocervical_nos.enabled": (state, value) => {
            if (!value) {
                state.impression.atypical_endocervical_nos.value = "";
            }
        },

        "impression.atypical_endocervical_nos.value": (state, value) => {
            state.impression.atypical_endocervical_nos.enabled = !!(value && String(value).trim());
        },

        "impression.atypical_endometrical.enabled": (state, value) => {
            if (!value) {
                state.impression.atypical_endometrical.value = "";
            }
        },

        "impression.atypical_endometrical.value": (state, value) => {
            state.impression.atypical_endometrical.enabled = !!(value && String(value).trim());
        },

        "impression.atypical_glandular_nos.enabled": (state, value) => {
            if (!value) {
                state.impression.atypical_glandular_nos.value = "";
            }
        },

        "impression.atypical_glandular_nos.value": (state, value) => {
            state.impression.atypical_glandular_nos.enabled = !!(value && String(value).trim());
        },

        "impression.empty_field.enabled": (state, value) => {
            if (!value) {
                state.impression.empty_field.value = "";
            }
        },

        
    };


const PAP_SMEAR_FIELD_MAPPING: FieldMapping = {
    // Specimen Details
    'specimenDetails.slides.slidesValue': {
        paramName: 'Received_Slides',
        type: 'free_text',
        getValue: (state: any) => state.specimenDetails.receivedType === 'slides' 
            ? state.specimenDetails.slides.slidesValue 
            : ''
    },
    'specimenDetails.liquid.liquidValue': {
        paramName: 'Received_liquid',
        type: 'free_text',
        getValue: (state: any) => state.specimenDetails.receivedType === 'liquid'
            ? state.specimenDetails.liquid.liquidValue 
            : ''
    },
    'specimenDetails.liquid.brushType.with': {
        paramName: 'Received_liquid_with_brush',
        type: 'checkbox',
        getValue: (state: any) => state.specimenDetails.receivedType === 'liquid' 
            && state.specimenDetails.liquid.brushType === 'with'
    },
    'specimenDetails.liquid.withoutBrushValue': {
        paramName: 'Received_liquid_without_brush',
        type: 'free_text',
        getValue: (state: any) => state.specimenDetails.receivedType === 'liquid'
            && state.specimenDetails.liquid.brushType === 'without'
            ? state.specimenDetails.liquid.withoutBrushValue 
            : ''
    },
    
    // Specimen Adequacy
    'specimenAdequacy.satisfactory': {
        paramName: 'Satisfactory_for_opinion',
        type: 'checkbox'
    },
    'specimenAdequacy.transformationZone.value': {
        paramName: 'Transformation_Zone',
        type: 'free_text',
        getValue: (state: any) => state.specimenAdequacy.transformationZone.enabled 
            ? (state.specimenAdequacy.transformationZone.value || '')
            : ''
    },
    'specimenAdequacy.interpretationLimited.reason': {
        paramName: 'Interpretation_limited_by',
        type: 'free_text',
        getValue: (state: any) => state.specimenAdequacy.interpretationLimited.enabled 
            ? (state.specimenAdequacy.interpretationLimited.reason || '')
            : ''
    },
    'specimenAdequacy.interpretationLimited.otherText': {
        paramName: 'Interpretation_limited_by_other',
        type: 'free_text',
        getValue: (state: any) => state.specimenAdequacy.interpretationLimited.reason === 'other'
            ? state.specimenAdequacy.interpretationLimited.otherText
            : ''
    },
    'specimenAdequacy.unsatisfactory.reason': {
        paramName: 'Unsatisfactory_for_opinion',
        type: 'free_text',
        getValue: (state: any) => state.specimenAdequacy.unsatisfactory.enabled 
            ? (state.specimenAdequacy.unsatisfactory.reason || '')
            : ''
    },
    'specimenAdequacy.unsatisfactory.otherText': {
        paramName: 'Unsatisfactory_for_opinion_other',
        type: 'free_text',
        getValue: (state: any) => state.specimenAdequacy.unsatisfactory.reason === 'other'
            ? state.specimenAdequacy.unsatisfactory.otherText
            : ''
    },
    
    // Findings
    'findings.endocervicalCells.value': {
        paramName: 'Endocervical_cells',
        type: 'free_text',
        getValue: (state: any) => state.findings.endocervicalCells.enabled 
            ? (state.findings.endocervicalCells.value || '')
            : ''
    },
    'findings.empty_field.value': {
        paramName: 'empty_field_one',
        type: 'free_text',
        getValue: (state: any) => state.findings.empty_field.enabled 
            ? state.findings.empty_field.value 
            : ''
    },
    'findings.inflammation.severity': {
        paramName: 'Reactive_cellular_changes_of_inflammation',
        type: 'free_text'
    },
    'findings.otherChanges.value': {
        paramName: 'Select_from_below_three',
        type: 'free_text'
    },
    
    // Organisms
    'findings.organisms.endoMetrical': {
        paramName: 'Endometrial_cells_present',
        type: 'checkbox'
    },
    'findings.organisms.trichomonas': {
        paramName: 'Trichomonas_vaginalis',
        type: 'checkbox'
    },
    'findings.organisms.candida': {
        paramName: 'Fungal_organisms_morphologically_consistent',
        type: 'checkbox'
    },
    'findings.organisms.bacterialVaginosis': {
        paramName: 'Shift_in_flora_suggestive_of_bacterial',
        type: 'checkbox'
    },
    'findings.organisms.actinomyces': {
        paramName: 'Bacteria_morphologically_consistent',
        type: 'checkbox'
    },
    'findings.organisms.hsv': {
        paramName: 'Cellular_changes_consistent_with_herpes',
        type: 'checkbox'
    },
    'findings.organisms.cmv': {
        paramName: 'Cellular_changes_consistent_with_cytomegalovirus',
        type: 'checkbox'
    },
    
    // Impression
    'impression.multiple_options.enabled': {
        paramName: 'Select_from_belows_two',
        type: 'free_text',
        getValue: (state: any) => state.impression.multiple_options.enabled 
            ? (state.impression.multiple_options.value || '')
            : ''
    },

    'impression.atypical_endocervical_nos': {
        paramName: 'Atypical_endocervical_cells',
        type: 'free_text',
        getValue: (state: any) => state.impression.atypical_endocervical_nos.enabled 
            ? state.impression.atypical_endocervical_nos.value 
            : ''
    },

    'impression.atypical_endometrical': {
        paramName: 'Atypical_endometrial_cells',
        type: 'free_text',
        getValue: (state: any) => state.impression.atypical_endometrical.enabled 
            ? state.impression.atypical_endometrical.value 
            : ''
    },

    'impression.atypical_glandular_nos': {
        paramName: 'Atypical_glandular_cells',
        type: 'free_text',
        getValue: (state: any) => state.impression.atypical_glandular_nos.enabled 
            ? state.impression.atypical_glandular_nos.value 
            : ''
    },

    'impression.empty_field': {
        paramName: 'empty_field_two',
        type: 'free_text',
        getValue: (state: any) => state.impression.empty_field.enabled 
            ? state.impression.empty_field.value 
            : ''
    },

    'impression.singleField.nilm': {
        paramName: 'Negative_for_intraepithelial_lesion',
        type: 'checkbox'
    },
    'impression.singleField.cellular_with_inflammation': {
        paramName: 'Reactive_cellular_changes_associated',
        type: 'checkbox'
    },
    'impression.singleField.atrophy': {
        paramName: 'Atrophy',
        type: 'checkbox'
    },
    'impression.singleField.ascus': {
        paramName: 'Atypical_squamous_cells_undetermined',
        type: 'checkbox'
    },
    'impression.singleField.lsil': {
        paramName: 'Low_grade_squamous',
        type: 'checkbox'
    },
    'impression.singleField.hsil': {
        paramName: 'high_grade_squamous',
        type: 'checkbox'
    },
    'impression.singleField.hsil_with_suspicious': {
        paramName: 'HSIL_with_features_suspicious',
        type: 'checkbox'
    },
    'impression.singleField.carcinoma': {
        paramName: 'Squamous_cell_carcinoma',
        type: 'checkbox'
    },
    'impression.singleField.endometrical_favor_neoplastic': {
        paramName: 'Atypical_endometrial_cells_favor_neoplastic',
        type: 'checkbox'
    },
    'impression.singleField.endocervical_favor_neoplastic': {
        paramName: 'Atypical_endocervical_cells_favor_neoplastic',
        type: 'checkbox'
    },
    'impression.singleField.situ': {
        paramName: 'Endocervical_adenocarcinoma_in_situ',
        type: 'checkbox'
    },
    'impression.singleField.endocervical_adenocarcinoma': {
        paramName: 'Endocervical_adenocarcinoma',
        type: 'checkbox'
    },
    'impression.singleField.endometrical_adenocarcinoma': {
        paramName: 'Endometrial_adenocarcinoma',
        type: 'checkbox'
    },
    'impression.singleField.extrauterine_adenocarcinoma': {
        paramName: 'Extrauterine_adenocarcinoma',
        type: 'checkbox'
    },
    'impression.singleField.adenocarcinoma_nos': {
        paramName: 'Adenocarcinoma_NOS',
        type: 'checkbox'
    },

    'advice.clinicalCorrelation':{
        paramName:'Clinical_correlation',
        type: 'checkbox'
    },

    'advice.reportSmear':{
        paramName:'Repeat_smear_after_control',
        type: 'checkbox'
    },

    'advice.colposcopicFollowUp':{
        paramName:'Colposcopic_follow_up_with',
        type: 'checkbox'
    }

    };

const getNestedValue = (obj: any, path: string): any => {
    return path.split('.').reduce((curr, key) => curr?.[key], obj);
};

const buildPapSmearPayload = (papReportDetails: any, existingParams: any[]): any[] => {
    const paramMap = new Map(existingParams.map(p => [p.parameter_name, p]));
    const payload: any[] = [];

    Object.entries(PAP_SMEAR_FIELD_MAPPING).forEach(([path, config]) => {
        let value = config.getValue 
            ? config.getValue(papReportDetails)
            : getNestedValue(papReportDetails, path);

        if (value === null || value === undefined) {
            value = "";
        }

       
        if (typeof value === 'boolean') {
            value = value;
        }

        const existing = paramMap.get(config.paramName);
        
       
        payload.push({
            ...(existing || {}),
            parameter_name: config.paramName,
            parameter_value: String(value),
            parameter_type: config.type,
            is_active: true,
            display_order: 0,
            parameter_url: "",
            parameter_code: ""
        });
    });

    return payload;
};

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];


        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HosptalID.length > 0) {
            HosptalID?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (reportListParameter && reportListParameter?.["pap-smear-temp"]) {
        const papSmearPayload = buildPapSmearPayload(
            papReportDetails,
            reportListParameter?.["pap-smear-temp"]
        );
        storeData.push(...papSmearPayload);
    }



        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
        }
    };
    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])

    const documentTitle = `${papReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

  
    const update = (path: string, value: any) => {
        setPapReportDetails((prev) => {
            const next = structuredClone(prev);
            const keys = path.split(".");
            let obj: any = next;

            for (let i = 0; i < keys.length - 1; i++) {
                const k = keys[i];
                if (obj[k] === undefined || obj[k] === null) {
                    obj[k] = {};
                }
                obj = obj[k];
            }

            obj[keys[keys.length - 1]] = value;

            // Apply rules for the exact path and all parent paths
            // Example: a change to `impression.singleField.ascus` should also trigger `impression.singleField`
            const pathParts = path.split(".");
            for (let i = pathParts.length; i >= 1; i--) {
                const rulePath = pathParts.slice(0, i).join(".");
                RULES[rulePath]?.(next, value);
            }

            return next;
        });
    };


     

    function normalizePapReport(apiResponse: any[]) {
        const map: Record<string, any> = {};
        apiResponse.forEach(item => {
            map[item.parameter_name] = item.parameter_value;
        });

        const isChecked = (v: any) => v === true || v === "true";

        return {
            specimenDetails: {
                receivedType: map.Received_Slides
                    ? "slides"
                    : map.Received_liquid
                        ? "liquid"
                        : null,

                slides: {
                    slidesValue: map.Received_Slides || "",
                },

                liquid: {
                    liquidValue: map.Received_liquid || "",
                    brushType: map.Received_liquid_with_brush
                        ? "with"
                        : map.Received_liquid_without_brush
                            ? "without"
                            : null,
                    withoutBrushValue: map.Received_liquid_without_brush || "",
                },
            },

            specimenAdequacy: {
                satisfactory: map.Satisfactory_for_opinion || false,

                transformationZone: {
                    enabled: map.Transformation_Zone !== "" ? true : false,
                    value: map.Transformation_Zone || null,
                },

                interpretationLimited: {
                    enabled: map.Interpretation_limited_by !== "" ? true : false,
                    reason: map.Interpretation_limited_by || null,
                    otherText: map.Interpretation_limited_by_other || "",
                },

                unsatisfactory: {
                    enabled: map.Unsatisfactory_for_opinion !== "" ? true : false,
                    reason: map.Unsatisfactory_for_opinion || null,
                    otherText: map.Unsatisfactory_for_opinion_other || "",
                },
            },

            findings: {
                endocervicalCells: {
                    enabled: map.Endocervical_cells !== "" ? true : false,
                    value: map.Endocervical_cells || null,
                },
                empty_field : {
                    enabled: map.empty_field_one !== "" ? true : false,
                    value: map.empty_field_one || ""
                },


                inflammation: {
                    severity: map.Reactive_cellular_changes_of_inflammation || null,
                },

                
                otherChanges: {                
                    value: map.Select_from_below_three || null,
                },

                organisms: {
                    endoMetrical: map.Endometrial_cells_present !=="" ? true : false,
                    trichomonas: map.Trichomonas_vaginalis !== "" ? true :  false,
                    candida: map.Fungal_organisms_morphologically_consistent !== "" ? true : false,
                    bacterialVaginosis: map.Shift_in_flora_suggestive_of_bacterial  !== "" ? true : false,
                    actinomyces: map.Bacteria_morphologically_consistent !== "" ? true : false,
                    hsv: map.Cellular_changes_consistent_with_herpes !=="" ? true : false,
                    cmv: map.Cellular_changes_consistent_with_cytomegalovirus !== "" ? true: false,
                },
            },

            impression: {
                multiple_options: {
                    enabled: map.Select_from_belows_two !=="" ? true : false,
                    value: map.Select_from_belows_two || null,
                },

                atypical_endocervical_nos: {
                    enabled: map.Atypical_endocervical_cells !=="" ? true : false,
                    value: map.Atypical_endocervical_cells || "",
                },

                atypical_endometrical: {
                    enabled: map.Atypical_endometrial_cells !== "" ? true : false,
                    value: map.Atypical_endometrial_cells || "",
                },

                atypical_glandular_nos: {
                    enabled: map.Atypical_glandular_cells !== "" ? true : false,
                    value: map.Atypical_glandular_cells || "",
                },

                empty_field: {
                    enabled: map.empty_field_two !== "" ? true : false,
                    value: map.empty_field_two || "",
                },

                singleField: {
                    nilm: isChecked(map.Negative_for_intraepithelial_lesion),
                    cellular_with_inflammation: isChecked(map.Reactive_cellular_changes_associated),
                    atrophy: isChecked(map.Atrophy),
                    ascus: isChecked(map.Atypical_squamous_cells_undetermined),
                    lsil: isChecked(map.Low_grade_squamous),
                    hsil: isChecked(map.high_grade_squamous),
                    hsil_with_suspicious: isChecked(map.HSIL_with_features_suspicious),
                    carcinoma: isChecked(map.Squamous_cell_carcinoma),
                    endometrical_favor_neoplastic: isChecked(map.Atypical_endometrial_cells_favor_neoplastic),
                    endocervical_favor_neoplastic: isChecked(map.Atypical_endocervical_cells_favor_neoplastic),
                    situ: isChecked(map.Endocervical_adenocarcinoma_in_situ),
                    endocervical_adenocarcinoma: isChecked(map.Endocervical_adenocarcinoma),
                    endometrical_adenocarcinoma: isChecked(map.Endometrial_adenocarcinoma),
                    extrauterine_adenocarcinoma: isChecked(map.Extrauterine_adenocarcinoma),
                    adenocarcinoma_nos: isChecked(map.Adenocarcinoma_NOS),
                },
            },

            advice: {
                clinicalCorrelation: isChecked(map.Clinical_correlation),
                repeatSmear: isChecked(map.Repeat_smear_after_control),
                colposcopicFollowUp: isChecked(map.Colposcopic_follow_up_with),
            },

            // advice: {
            //     clinicalCorrelation: map.Clinical_correlation || false,
            //     reportSmear: map.Repeat_smear_after_control || false,
            //     colposcopicFollowUp: map.Colposcopic_follow_up_with || false,
                
            // }
        };
    }


    useEffect(() => {
        if (reportListParameter && reportListParameter?.["pap-smear-temp"]?.length) {
            const normalized: any = normalizePapReport(reportListParameter?.["pap-smear-temp"]);
            setPapReportDetails(normalized);
        }
    }, [reportListParameter]);


     console.log(papReportDetails,"dskcjsdncisdncsdiu")






    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className="input"
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="papReport__header pml-page-headers">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>


                    <table className="papReport__printTable">
                        <thead className="papReport__printTable-head"><tr><td><div className="papReport__headerSpacer" /></td></tr></thead>
                        <tfoot className="papReport__printTable-foot"><tr><td><div className="papReport__footerSpacer" /></td></tr></tfoot>
                        <tbody><tr><td>
                    <div className="papReport__body">
                    <div className="papReport__spacer papReport__spacer--afterHeader pml-main-content3" aria-hidden="true" />
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "30px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#400354" }}>PAP</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>SMEAR</span>
                    </div>


                    {/* patient details page 1 */}
                    <Paper className="papReport__patientCard" style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "25px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="papReport__patientGrid pml-marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {papReport[0]?.pk
                                                ? papReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Age
                                        </Grid>
                                        {dob === "" || dob === null ? (
                                            <Grid item xs={8.5}>
                                                :

                                                <> <input
                                                    className="input"
                                                    style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                    type="text"
                                                    value={age}
                                                    onChange={(e) => setAge(e.target.value)} />Y
                                                </>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={8.5}>
                                                :

                                                <span> {age} Y</span>
                                            </Grid>
                                        )
                                        }
                                    </div>
                                </Grid>


                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :

                                            <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    {papReport[0]?.center?.name && papReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HosptalID?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalId(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>


                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord</option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA</option>
                                                        <option value="tissue"> FFPE TISSUE BLOCK</option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "92%", marginLeft: "47px" }}>
                        <h6 className="papReport__sectionHeader" style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{papReport[0]?.packages[0]?.name}</h6>
                    </div>

                    {/* specimen details */}
                    <div className="section-header-clean" style={{ margin: "0 45px" }}>
                        SPECIMEN DETAILS
                    </div>

                    <div className="specimen-details-content" style={{ margin: "0 45px" }}>
                        <div className="specimen-radio-item">

                            {/* SLIDES */}
                            <label className="papOption specimen-radio-row indent-level-1">
                                <input
                                    type="radio"
                                    name="specimen"
                                    checked={papReportDetails.specimenDetails.receivedType === "slides"}
                                    onChange={() =>
                                        update("specimenDetails.receivedType", "slides")
                                    }
                                />

                                <span>Received</span>

                                <input
                                    type="text"
                                    className="enhanced-line-input"
                                    style={{ width: 120 }}
                                    value={papReportDetails.specimenDetails.slides.slidesValue}
                                    onChange={(e) =>
                                        update("specimenDetails.slides.slidesValue", e.target.value)
                                    }
                                />

                                <span>slides, stained with PAP stain.</span>
                            </label>

                            {/* LIQUID */}
                            <label className="papOption specimen-radio-row indent-level-1">
                                <input
                                    type="radio"
                                    name="specimen"
                                    checked={papReportDetails.specimenDetails.receivedType === "liquid"}
                                    onChange={() =>
                                        update("specimenDetails.receivedType", "liquid")
                                    }
                                />

                                <span>Received</span>

                                <input
                                    type="text"
                                    className="enhanced-line-input"
                                    style={{ width: 120 }}
                                    value={papReportDetails.specimenDetails.liquid.liquidValue}
                                    onChange={(e) =>
                                        update("specimenDetails.liquid.liquidValue", e.target.value)
                                    }
                                />

                                <span>ml liquid based sample</span>
                            </label>
                        </div>

                        {/* SUB OPTIONS — only show when LIQUID */}
                        {papReportDetails.specimenDetails.receivedType === "liquid" && (
                            <div className="indent-level-2" style={{ marginLeft: 48, marginTop: 8 }}>

                                {/* WITH BRUSH */}
                                <label className="papOption specimen-radio-sub">
                                    <input
                                        type="radio"
                                        name="specimenSub"
                                        checked={
                                            papReportDetails.specimenDetails.liquid.brushType === "with"
                                        }
                                        onChange={() =>
                                            update("specimenDetails.liquid.brushType", "with")
                                        }
                                    />
                                    with brush
                                </label>

                                {/* WITHOUT BRUSH */}
                                <label className="papOption specimen-radio-sub">
                                    <input
                                        type="radio"
                                        name="specimenSub"
                                        checked={
                                            papReportDetails.specimenDetails.liquid.brushType === "without"
                                        }
                                        onChange={() =>
                                            update("specimenDetails.liquid.brushType", "without")
                                        }
                                    />

                                    <span>without brush</span>

                                    <input
                                        type="text"
                                        className="enhanced-line-input"
                                        style={{ width: 60 }}
                                        value={papReportDetails.specimenDetails.liquid.withoutBrushValue}
                                        onChange={(e) =>
                                            update(
                                                "specimenDetails.liquid.withoutBrushValue",
                                                e.target.value
                                            )
                                        }
                                    />

                                    <span>smear(s) prepared and stained with PAP stain.</span>
                                </label>
                            </div>
                        )}
                    </div>




                    <div className="section-header-clean" style={{ margin: "0 45px" }}>
                        SPECIMEN ADEQUACY
                    </div>

                    <div className="specimen-adequacy-content" style={{ margin: "0 45px" }}>
                        <div style={{ fontFamily: "Arial", fontSize: 15 }}>
                            {/* Satisfactory */}
                            <div className="adequacy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.satisfactory} >
                                    <input type="checkbox" checked={papReportDetails?.specimenAdequacy?.satisfactory} onChange={(e: any) => update("specimenAdequacy.satisfactory", e.target.checked)} />
                                    <strong>Satisfactory for opinion</strong>
                                </label>
                            </div>

                            {/* Transformation Zone */}
                            <div className="adequacy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.transformationZone.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.specimenAdequacy?.transformationZone.enabled} onChange={(e: any) => update("specimenAdequacy.transformationZone.enabled", e.target.checked)} />
                                    <strong>Transformation Zone</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.transformationZone.value === "present"} >
                                        <input name="transformationZone" type="radio" checked={papReportDetails?.specimenAdequacy?.transformationZone?.value === "present"} onChange={(e: any) => update("specimenAdequacy.transformationZone.value", "present")} /> Present
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.transformationZone.value === "absent"} >
                                        <input name="transformationZone" type="radio" checked={papReportDetails?.specimenAdequacy?.transformationZone.value === "absent"} onChange={() => update("specimenAdequacy.transformationZone.value", "absent")} /> Absent
                                    </label>
                                </div>
                            </div>

                            {/* Interpretation limited by */}
                            <div className="adequacy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.enabled} onChange={(e: any) => update("specimenAdequacy.interpretationLimited.enabled", e.target.checked)} />
                                    <strong>Interpretation limited by:</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "blood"} >
                                        <input name="interpretationLimitedBy" type="radio" checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "blood"} onChange={() => update("specimenAdequacy.interpretationLimited.reason", "blood")} /> obscuring blood
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "inflammation"} >
                                        <input name="interpretationLimitedBy" type="radio" checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "inflammation"} onChange={() => update("specimenAdequacy.interpretationLimited.reason", "inflammation")} /> obscuring inflammation
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "other"} >
                                        <input name="interpretationLimitedBy" type="radio" checked={papReportDetails?.specimenAdequacy?.interpretationLimited?.reason === "other"} onChange={() => update("specimenAdequacy.interpretationLimited.reason", "other")} /> other:
                                        <input className="enhanced-line-input" value={papReportDetails?.specimenAdequacy?.interpretationLimited?.otherText} onChange={(e) => update("specimenAdequacy.interpretationLimited.otherText", e.target.value)} />
                                    </label>
                                </div>
                            </div>

                            {/* Unsatisfactory */}
                            <div className="adequacy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.enabled} onChange={(e: any) => update("specimenAdequacy.unsatisfactory.enabled", e.target.checked)} />
                                    <strong>Unsatisfactory for opinion</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.reason === "insufficient"} >
                                        <input name="unsatisfactory" type="radio" checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.reason === "insufficient"} onChange={() => update("specimenAdequacy.unsatisfactory.reason", "insufficient")} /> insufficient squamous cellularity
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.reason === "other"} >
                                        <input name="unsatisfactory" type="radio" checked={papReportDetails?.specimenAdequacy?.unsatisfactory?.reason === "other"} onChange={() => update("specimenAdequacy.unsatisfactory.reason", "other")} /> other:
                                        <input className="enhanced-line-input" value={papReportDetails?.specimenAdequacy?.unsatisfactory?.otherText} onChange={(e) => update("specimenAdequacy.unsatisfactory.otherText", e.target.value)} />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>




                    {/* Microscopy - REPLACE THIS ENTIRE SECTION */}
                    <div className="section-header-clean" style={{ margin: "0 45px" }}>
                        MICROSCOPY
                    </div>

                    <div className="microscopy-content" style={{ margin: "0 45px" }}>
                        <div style={{ fontFamily: "Arial", fontSize: 15 }}>
                            <div className="microscopy-statement">
                                Smear shows adequate number of superficial, intermediate squamous cells and parabasal cells.
                            </div>

                            {/* Endocervical cells */}
                            <div className="microscopy-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails?.findings?.endocervicalCells?.enabled}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.endocervicalCells?.enabled}
                                        onChange={(e) =>
                                            update(
                                                "findings.endocervicalCells",
                                                e.target.checked
                                                    ? { enabled: true, value: null }
                                                    : { enabled: false, value: null }
                                            )
                                        }
                                    />
                                    <strong>Endocervical cells</strong>
                                </label>


                                <div className="indent-level-2">
                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.endocervicalCells?.value === "present"}
                                        
                                    >
                                        <input
                                            name="endocervicalCells"
                                            type="radio"
                                            checked={papReportDetails?.findings?.endocervicalCells?.value === "present"}
                                            onChange={() =>
                                                update("findings.endocervicalCells.value", "present")
                                            }
                                        />
                                        Present
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.endocervicalCells?.value === "absent"}
                                        
                                    >
                                        <input
                                            name="endocervicalCells"
                                            type="radio"
                                            checked={papReportDetails?.findings?.endocervicalCells?.value === "absent"}
                                            onChange={() =>
                                                update("findings.endocervicalCells.value", "absent")
                                            }
                                        />
                                        Absent
                                    </label>
                                </div>

                            </div>

                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.findings?.empty_field?.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.findings?.empty_field?.enabled} onChange={(e: any) => update("findings.empty_field.enabled", e.target.checked)} />
                                    <input className="enhanced-line-input" value={papReportDetails?.findings?.empty_field?.value} onChange={(e: any) => update("findings.empty_field.value", e.target.value)} />
                                </label>
                            </div>


                            {/* Reactive cellular changes */}
                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="row" >
                                    <strong>Reactive cellular changes of inflammation noted with:</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.inflammation?.severity === "mild"}
                                        
                                    >
                                        <input
                                            name="reactive-cellular"
                                            type="radio"
                                            checked={papReportDetails?.findings?.inflammation?.severity === "mild"}
                                            onChange={() =>
                                                update("findings.inflammation", {
                                                    enabled: true,
                                                    severity: "mild",
                                                })
                                            }
                                        />
                                        mild
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.inflammation?.severity === "moderate"}
                                        
                                    >
                                        <input
                                            name="reactive-cellular"
                                            type="radio"
                                            checked={papReportDetails?.findings?.inflammation?.severity === "moderate"}
                                            onChange={() =>
                                                update("findings.inflammation", {
                                                    enabled: true,
                                                    severity: "moderate",
                                                })
                                            }
                                        />
                                        moderate
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.inflammation?.severity === "marked"}
                                        
                                    >
                                        <input
                                            name="reactive-cellular"
                                            type="radio"
                                            checked={papReportDetails?.findings?.inflammation?.severity === "marked"}
                                            onChange={() =>
                                                update("findings.inflammation", {
                                                    enabled: true,
                                                    severity: "marked",
                                                })
                                            }
                                        />
                                        marked neutrophilic infiltrate
                                    </label>
                                </div>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="row" >
                                    <strong>Select from below</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.otherChanges?.value === "metaplasia"}
                                        
                                    >
                                        <input
                                            name="microscopy-select-below"
                                            type="radio"
                                            checked={papReportDetails?.findings?.otherChanges?.value === "metaplasia"}
                                            onChange={() =>
                                                update("findings.otherChanges.value", "metaplasia")
                                            }
                                        />
                                        Squamous metaplasia
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.otherChanges?.value === "keratotic"}
                                        
                                    >
                                        <input
                                            name="microscopy-select-below"
                                            type="radio"
                                            checked={papReportDetails?.findings?.otherChanges?.value === "keratotic"}
                                            onChange={() =>
                                                update("findings.otherChanges.value", "keratotic")
                                            }
                                        />
                                        Keratotic changes
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.otherChanges?.value === "atrophy"}
                                        
                                    >
                                        <input
                                            name="microscopy-select-below"
                                            type="radio"
                                            checked={papReportDetails?.findings?.otherChanges?.value === "atrophy"}
                                            onChange={() =>
                                                update("findings.otherChanges.value", "atrophy")
                                            }
                                        />
                                        Atrophy
                                    </label>
                                </div>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.findings?.organisms?.endoMetrical} >
                                    <input type="checkbox" checked={papReportDetails?.findings?.organisms?.endoMetrical} onChange={(e: any) => update("findings.organisms.endoMetrical", e.target.checked)} />
                                    <strong>Endometrial cells present (in patients 45 years of age or older)</strong>
                                </label>
                            </div>

                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.findings?.organisms?.trichomonas !== null}>
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.trichomonas !== null}
                                        onChange={(e: any) =>
                                            update(
                                                "findings.organisms.trichomonas",
                                                e.target.checked ? "seen" : null
                                            )
                                        }
                                    />
                                    <strong>Trichomonas vaginalis</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.organisms?.trichomonas === "seen"}
                                        
                                    >
                                        <input
                                            name="trichomonas"
                                            type="radio"
                                            checked={papReportDetails?.findings?.organisms?.trichomonas === "seen"}
                                            disabled={papReportDetails?.findings?.organisms?.trichomonas === null}
                                            onChange={() =>
                                                update("findings.organisms.trichomonas", "seen")
                                            }
                                        />
                                        seen
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.organisms?.trichomonas === "not_seen"}
                                        
                                    >
                                        <input
                                            name="trichomonas"
                                            type="radio"
                                            checked={papReportDetails?.findings?.organisms?.trichomonas === "not_seen"}
                                            disabled={papReportDetails?.findings?.organisms?.trichomonas === null}
                                            onChange={() =>
                                                update("findings.organisms.trichomonas", "not_seen")
                                            }
                                        />
                                        Not seen
                                    </label>
                                </div>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.findings?.organisms?.candida !== null}>
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.candida !== null}
                                        onChange={(e: any) =>
                                            update(
                                                "findings.organisms.candida",
                                                e.target.checked ? "seen" : null
                                            )
                                        }
                                    />
                                    <strong>Fungal organisms morphologically consistent with Candida species</strong>
                                </label>

                                <div className="indent-level-2">
                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.organisms?.candida === "seen"}
                                        
                                    >
                                        <input
                                            name="candida"
                                            type="radio"
                                            checked={papReportDetails?.findings?.organisms?.candida === "seen"}
                                            disabled={papReportDetails?.findings?.organisms?.candida === null}
                                            onChange={() =>
                                                update("findings.organisms.candida", "seen")
                                            }
                                        />
                                        seen
                                    </label>

                                    <label
                                        className="papOption row"
                                        data-checked={papReportDetails?.findings?.organisms?.candida === "not_seen"}
                                        
                                    >
                                        <input
                                            name="candida"
                                            type="radio"
                                            checked={papReportDetails?.findings?.organisms?.candida === "not_seen"}
                                            disabled={papReportDetails?.findings?.organisms?.candida === null}
                                            onChange={() =>
                                                update("findings.organisms.candida", "not_seen")
                                            }
                                        />
                                        Not seen
                                    </label>
                                </div>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails?.findings?.organisms?.bacterialVaginosis}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.bacterialVaginosis}
                                        onChange={(e) =>
                                            update(
                                                "findings.organisms.bacterialVaginosis",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Shift in flora suggestive of bacterial vaginosis</strong>
                                </label>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails?.findings?.organisms?.actinomyces}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.actinomyces}
                                        onChange={(e) =>
                                            update(
                                                "findings.organisms.actinomyces",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Bacteria morphologically consistent with Actinomyces species</strong>
                                </label>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails?.findings?.organisms?.hsv}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.hsv}
                                        onChange={(e) =>
                                            update("findings.organisms.hsv", e.target.checked)
                                        }
                                    />
                                    <strong>Cellular changes consistent with herpes simplex virus</strong>
                                </label>
                            </div>


                            <div className="microscopy-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails?.findings?.organisms?.cmv}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails?.findings?.organisms?.cmv}
                                        onChange={(e) =>
                                            update("findings.organisms.cmv", e.target.checked)
                                        }
                                    />
                                    <strong>Cellular changes consistent with cytomegalovirus</strong>
                                </label>
                            </div>

                        </div>
                    </div>



                    {/* Impression - REPLACE THIS ENTIRE SECTION */}

                    <div className="section-header-clean" style={{ margin: "0 45px" }}>
                        IMPRESSION (2014 BETHESDA SYSTEM TERMINOLOGY)
                    </div>

                    <div className="impression-content" style={{ margin: "0 45px" }}>
                        <div style={{ fontFamily: "Arial", fontSize: 15 }}>
                            <div className="impression-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails.impression.singleField.nilm}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails.impression.singleField.nilm}
                                        onChange={(e) =>
                                            update(
                                                "impression.singleField.nilm",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Negative for intraepithelial lesion or malignancy (NILM)</strong>
                                </label>

                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails.impression.singleField.cellular_with_inflammation}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails.impression.singleField.cellular_with_inflammation}
                                        onChange={(e) =>
                                            update(
                                                "impression.singleField.cellular_with_inflammation",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Reactive cellular changes associated with inflammation</strong>
                                </label>

                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails.impression.singleField.atrophy}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails.impression.singleField.atrophy}
                                        onChange={(e) =>
                                            update(
                                                "impression.singleField.atrophy",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Atrophy</strong>
                                </label>

                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.enabled} >
                                    <input type="checkbox" checked={papReportDetails.impression.multiple_options.enabled} onChange={(e: any) => update("impression.multiple_options.enabled", e.target.checked)} />
                                    <strong>Select from below</strong>
                                </label>
                                <div className="indent-level-2">
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "trichomonas"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "trichomonas"} onChange={() => update("impression.multiple_options.value", "trichomonas")} /> Trichomonas vaginalis
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "candida"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "candida"} onChange={() => update("impression.multiple_options.value", "candida")} /> Candida species
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "bv"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "bv"} onChange={() => update("impression.multiple_options.value", "bv")} /> Bacterial vaginosis
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "actinomyces"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "actinomyces"} onChange={() => update("impression.multiple_options.value", "actinomyces")} /> Actinomyces
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "herpes"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "herpes"} onChange={() => update("impression.multiple_options.value", "herpes")} /> Herpes simplex virus associated changes
                                    </label>
                                    <label className="papOption row" data-checked={papReportDetails.impression.multiple_options.value === "cmv"} >
                                        <input name="impression-select-below" type="radio" checked={papReportDetails.impression.multiple_options.value === "cmv"} onChange={() => update("impression.multiple_options.value", "cmv")} /> CMV associated changes
                                    </label>
                                </div>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.ascus} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.ascus} onChange={(e: any) => update("impression.singleField.ascus", e.target.checked)} />
                                    <strong>Atypical squamous cells – undetermined significance (ASC-US)</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.lsil} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.lsil} onChange={(e: any) => update("impression.singleField.lsil", e.target.checked)} />
                                    <strong>Low-grade squamous intraepithelial lesion (LSIL)</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.hsil} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.hsil} onChange={(e: any) => update("impression.singleField.hsil", e.target.checked)} />
                                    <strong>High-grade squamous intraepithelial lesion (HSIL)</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.hsil_with_suspicious} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.hsil_with_suspicious} onChange={(e: any) => update("impression.singleField.hsil_with_suspicious", e.target.checked)} />
                                    <strong>HSIL with features suspicious for invasion</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.carcinoma} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.carcinoma} onChange={(e: any) => update("impression.singleField.carcinoma", e.target.checked)} />
                                    <strong>Squamous cell carcinoma</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails.impression.atypical_endocervical_nos.enabled}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails.impression.atypical_endocervical_nos.enabled}
                                        onChange={(e) =>
                                            update(
                                                "impression.atypical_endocervical_nos.enabled",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Atypical endocervical cells (NOS or specify)</strong>

                                    <input
                                        className="enhanced-line-input"
                                        value={papReportDetails.impression.atypical_endocervical_nos.value}
                                        disabled={!papReportDetails.impression.atypical_endocervical_nos.enabled}
                                        onChange={(e) =>
                                            update(
                                                "impression.atypical_endocervical_nos.value",
                                                e.target.value
                                            )
                                        }
                                    />
                                </label>

                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.atypical_endometrical?.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.atypical_endometrical?.enabled} onChange={(e: any) => update("impression.atypical_endometrical.enabled", e.target.checked)} />
                                    <strong>Atypical endometrial cells:</strong>
                                    <input className="enhanced-line-input" value={papReportDetails?.impression?.atypical_endometrical?.value} onChange={(e) => update("impression.atypical_endometrical.value", e.target.value)} />
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label
                                    className="papOption row"
                                    data-checked={papReportDetails.impression.atypical_glandular_nos.enabled}
                                    
                                >
                                    <input
                                        type="checkbox"
                                        checked={papReportDetails.impression.atypical_glandular_nos.enabled}
                                        onChange={(e) =>
                                            update(
                                                "impression.atypical_glandular_nos.enabled",
                                                e.target.checked
                                            )
                                        }
                                    />
                                    <strong>Atypical glandular cells (NOS or specify)</strong>

                                    <input
                                        className="enhanced-line-input"
                                        value={papReportDetails.impression.atypical_glandular_nos.value}
                                        disabled={!papReportDetails.impression.atypical_glandular_nos.enabled}
                                        onChange={(e) =>
                                            update(
                                                "impression.atypical_glandular_nos.value",
                                                e.target.value
                                            )
                                        }
                                    />
                                </label>

                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.singleField?.endometrical_favor_neoplastic} >
                                    <input type="checkbox" checked={papReportDetails.impression.singleField?.endometrical_favor_neoplastic} onChange={(e: any) => update("impression.singleField.endometrical_favor_neoplastic", e.target.checked)} />
                                    <strong>Atypical endometrial cells favor neoplastic</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.singleField?.endocervical_favor_neoplastic} >
                                    <input type="checkbox" checked={papReportDetails.impression.singleField?.endocervical_favor_neoplastic} onChange={(e: any) => update("impression.singleField.endocervical_favor_neoplastic", e.target.checked)} />
                                    <strong>Atypical endocervical cells, favor neoplastic</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.singleField?.situ} >
                                    <input type="checkbox" checked={papReportDetails.impression.singleField?.situ} onChange={(e: any) => update("impression.singleField.situ", e.target.checked)} />
                                    <strong>Endocervical adenocarcinoma in situ</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.singleField?.endocervical_adenocarcinoma} >
                                    <input type="checkbox" checked={papReportDetails.impression.singleField?.endocervical_adenocarcinoma} onChange={(e: any) => update("impression.singleField.endocervical_adenocarcinoma", e.target.checked)} />
                                    <strong>Endocervical adenocarcinoma</strong>
                                </label>
                            </div>


                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails.impression.singleField?.endometrical_adenocarcinoma} >
                                    <input type="checkbox" checked={papReportDetails.impression.singleField?.endometrical_adenocarcinoma} onChange={(e: any) => update("impression.singleField.endometrical_adenocarcinoma", e.target.checked)} />
                                    <strong>Endometrial adenocarcinoma</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression.singleField?.extrauterine_adenocarcinoma} >
                                    <input type="checkbox" checked={papReportDetails?.impression.singleField?.extrauterine_adenocarcinoma} onChange={(e: any) => update("impression.singleField.extrauterine_adenocarcinoma", e.target.checked)} />
                                    <strong>Extrauterine adenocarcinoma</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.singleField?.adenocarcinoma_nos} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.singleField?.adenocarcinoma_nos} onChange={(e: any) => update("impression.singleField.adenocarcinoma_nos", e.target.checked)} />
                                    <strong>Adenocarcinoma NOS</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.impression?.empty_field?.enabled} >
                                    <input type="checkbox" checked={papReportDetails?.impression?.empty_field?.enabled} onChange={(e: any) => update("impression.empty_field.enabled", e.target.checked)} />
                                    <input className="enhanced-line-input" value={papReportDetails?.impression?.empty_field?.value} onChange={(e) => update("impression.empty_field.value", e.target.value)} />
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="section-header-clean" style={{ margin: "0 45px" }}>
                        ADVICE
                    </div>

                    <div className="impression-content" style={{ margin: "0 45px" }}>
                        <div style={{ fontFamily: "Arial", fontSize: 15 }}>
                            

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.advice?.clinicalCorrelation} >
                                    <input type="checkbox" checked={papReportDetails?.advice?.clinicalCorrelation} onChange={(e: any) => update("advice.clinicalCorrelation", e.target.checked)} />
                                    <strong>Clinical correlation</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.advice?.repeatSmear} >
                                    <input type="checkbox" checked={papReportDetails?.advice?.repeatSmear} onChange={(e: any) => update("advice.repeatSmear", e.target.checked)} />
                                    <strong>Repeat smear after control of inflammation</strong>
                                </label>
                            </div>

                            <div className="impression-checkbox-item indent-level-1">
                                <label className="papOption row" data-checked={papReportDetails?.advice?.colposcopicFollowUp} >
                                    <input type="checkbox" checked={papReportDetails?.advice?.colposcopicFollowUp} onChange={(e: any) => update("advice.colposcopicFollowUp", e.target.checked)} />
                                    <strong>Colposcopic follow-up with lesional biopsy</strong>
                                </label>
                            </div>

                            
                           


                           
                        </div>
                    </div>



                    {/* Interpretative guideline - REPLACE THIS ENTIRE SECTION */}
                    <div className="section-header-clean interpretation-guideline" style={{ margin: "0 45px" }}>
                        INTERPRETATIVE GUIDELINE
                    </div>

                    <div className="guideline-content" style={{ margin: "0 45px" }}>
                        <div style={{ fontFamily: "Arial", fontSize: 15 }}>
                            <div className="guideline-subtitle">
                                (Based on the Bethesda System, HPV status, and ASCCP 2019/2020 Guidelines)
                            </div>

                            <table className="guideline-table">
                                <thead>
                                    <tr>
                                        <th>Bethesda Category</th>
                                        <th>Approx. Risk of Malignancy / CIN3+</th>
                                        <th>Impact of HPV Status</th>
                                        <th>Recommended Management (ASCCP 2019/20)</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>NILM (Negative for Intraepithelial Lesion or Malignancy)</td>
                                        <td>Very low</td>
                                        <td>
                                            HPV negative: very low risk → eligible for 5-year interval.
                                            <br />
                                            HPV positive: elevated risk.
                                        </td>
                                        <td>
                                            HPV negative → routine screening.
                                            <br />
                                            HPV positive → repeat HPV/Pap in 1 year; colposcopy if persistent (esp. HPV 16/18).
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>ASC-US (Atypical Squamous Cells of Undetermined Significance)</td>
                                        <td>~2–5%</td>
                                        <td>
                                            HPV negative → risk drops.
                                            <br />
                                            HPV positive → risk increases.
                                        </td>
                                        <td>
                                            HPV testing preferred.
                                            <br />
                                            If HPV negative → 3-year return.
                                            <br />
                                            If HPV positive → colposcopy.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>ASC-H (Atypical Squamous Cells – cannot exclude HSIL)</td>
                                        <td>High</td>
                                        <td>HPV positive (esp. 16/18) → very high risk.</td>
                                        <td>
                                            Colposcopy in all cases.
                                            <br />
                                            Expedited excisional treatment may be considered if HPV16+ or unscreened &gt;5 years.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>LSIL (Low-Grade Squamous Intraepithelial Lesion)</td>
                                        <td>~5–15%</td>
                                        <td>
                                            HPV positive → colposcopy.
                                            <br />
                                            HPV negative → lower risk.
                                        </td>
                                        <td>
                                            Colposcopy if HPV positive.
                                            <br />
                                            If HPV negative and age ≥30 → repeat testing in 1 year.
                                            <br />
                                            Adolescents/young women → conservative follow-up.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>HSIL (High-Grade Squamous Intraepithelial Lesion)</td>
                                        <td>~25–60%</td>
                                        <td>
                                            HPV positive → immediate CIN3+ risk up to 77% → <strong>expedited treatment preferred</strong>.
                                        </td>
                                        <td>
                                            Colposcopy or expedited excisional treatment (LEEP).
                                            <br />
                                            HPV16+ HSIL → expedited treatment strongly preferred.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Squamous Cell Carcinoma</td>
                                        <td>Very high</td>
                                        <td>Usually HPV positive.</td>
                                        <td>Immediate colposcopy, biopsy confirmation, and oncology referral.</td>
                                    </tr>

                                    <tr>
                                        <td>AGC (Atypical Glandular Cells)</td>
                                        <td>~9–38%</td>
                                        <td>HPV positive → higher risk of adenocarcinoma in situ (AIS) or invasive cancer.</td>
                                        <td>
                                            Colposcopy with endocervical sampling.
                                            <br />
                                            Endometrial sampling if ≥35 years or abnormal bleeding.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Endocervical Adenocarcinoma in situ (AIS)</td>
                                        <td>High</td>
                                        <td>HPV18 positive.</td>
                                        <td>
                                            Colposcopy + diagnostic excisional procedure.
                                            <br />
                                            Definitive hysterectomy if fertility not required.
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Endocervical Adenocarcinoma</td>
                                        <td>Very high</td>
                                        <td>HPV18 positive.</td>
                                        <td>Immediate colposcopy, biopsy, and oncology referral.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>




                    {/* Disclaimer - REPLACE THIS ENTIRE SECTION */}
                    <div className="section-header-clean disclaimer-section" style={{ margin: "0 45px" }}>
                        DISCLAIMER
                    </div>

                    <div className="disclaimer-content" style={{ margin: "0 45px" }}>
                        <ul>
                            <li>
                                <p>The Pap smear is a screening test, not a diagnostic tool.</p>
                            </li>
                            <li>
                                <p>False negatives/positives can occur due to sampling or interpretation limitations.</p>
                            </li>
                            <li>
                                <p>Accurate diagnosis requires correlation with HPV testing, colposcopy, histopathology, and clinical findings.</p>
                            </li>
                            <li>
                                <p>Management should follow the 2019 ASCCP Risk-Based Guidelines and take into account patient's age, prior screening history, and comorbidities.</p>
                            </li>
                        </ul>
                    </div>


                    {/* Refrences */}
                    <div className="section-header-clean" style={{ margin: "0 45px" }} >
                        REFERENCES
                    </div>


                    <div className="disclaimer-content" style={{ margin: "0 45px" }}>
                        <ol >
                            <li style={{ wordWrap: 'break-word' }}>Schrijver, Iris, Sarah C. Cherny, and James L. Zehnder. "Testing for maternal cell contamination in prenatal samples: a comprehensive survey of current
                                diagnostic practices in 35 molecular diagnostic laboratories." The Journal of Molecular Diagnostics 9, no. 3 (2007): 394-400.</li>
                            <li>American College of Medical Genetics-Standards and Guidelines for Clinical Genetics Laboratories, 2006 Edition.</li>
                            <li>Nagan, Narasimhan, Nicole E. Faulkner, Christine Curtis, and Iris Schrijver. "Laboratory guidelines for detection, interpretation, and reporting of maternal
                                cell contamination in prenatal analysis: a report of the association for molecular pathology." The Journal of Molecular Diagnostics 13, no. 1 (2011): 7-11.</li>
                            <li>Steinberg, S., Sara Katsanis, A. Moser, and G. Cutting. "Biochemical analysis of cultured chorionic villi for the prenatal diagnosis of peroxisomal
                                disorders: biochemical thresholds and molecular sensitivity for maternal cell contamination detection." Journal of medical genetics 42, no. 1 (2005): 38-44.</li>
                            <li>Langlois S, Duncan A; SOGC GENETICS COMMITTEE; CCMG PRENATAL DIAGNOSIS COMMITTEE. Use of a DNA method, QF-PCR,in the prenatal
                                diagnosis of fetal aneuploidies. J Obstet Gynaecol Can. 2011 Sep;33(9):955-960.</li>
                            <li>Phan, T. Quantitative Fluorescent Polymerase Chain Reaction for Prenatal Diagnosis and Its Application in Vietnam: A Literature Review. Preprints 2021,
                                2021060285.</li>
                        </ol>
                        <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "20px" }}>Important: On doing PNDT test, the undersigned hereby confirms that no sex chromosome information has been passed on to anyone in
                            whatsoever manner.</p>
                    </div>
                    <div style={{ width: "80%", marginLeft: "60px", textAlign: "center", marginTop: "20px" }}><h5>Disclaimer- The sample is processed at the PC-PNDT certified laboratory</h5></div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around' }}>
                        {pmldoctorList && pmldoctorList?.length > 0 && pmldoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {pmldoctorList && pmldoctorList?.length > 0 && pmldoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    </div>
                    </td></tr></tbody>
                    </table>
                    {/* footer section starting */}
                    <div className="papReport__footer pml-page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="pml-box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                    {uuid && <div className="hide-section-rating">
                        <NpsRating bookingId={firstP} uuid={uuid} />
                    </div>}


                </div>
            </div >
        </Grammarly>
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(PapSmearReport);



